import { render } from "./cStudyDesign.vue?vue&type=template&id=efc4ab64"
import script from "./cStudyDesign.vue?vue&type=script&lang=js"
export * from "./cStudyDesign.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__